module.exports = __webpack_public_path__ + "static/media/finalcart.817f8d5b.png";